export * from './lib/multi-search-filter.module';
export { AccredibleMultiSearchFilterComponent } from './lib/multi-search-filter.component';
